/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NameAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function NameAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Templates/Content/Content/NameAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnSubmit({
  children,
  viewPath
  
})
let noteTemplateNameValueData = fromData.useDataValue({ viewPath,
context: 'note_template',
path: 'name',
})
  return (<React.Fragment
>
<button
  data-testid="NameAction.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="note_template.name"
 text={noteTemplateNameValueData}
 size="small"
/>
</button>
{children}
</React.Fragment>)
}